/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_OfficeInputs */

const cs_enum_office = /** @type {(inputs: Enum_OfficeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kancelář`)
};

const en_enum_office = /** @type {(inputs: Enum_OfficeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Office`)
};

/**
* | output |
* | --- |
* | "Office" |
*
* @param {Enum_OfficeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_office = /** @type {((inputs?: Enum_OfficeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_OfficeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_office(inputs)
	return cs_enum_office(inputs)
});